// src/components/proposals/proposalStatus.js
//
// The proposal status enum and its chip palette, in a module with NO imports.
//
// It lives here rather than in ProposalsTab for the same reason docTypes.js
// lives apart from templateDefaults: ProposalsTab pulls in ContractsPanel, which
// pulls in apiClient, which constructs the MSAL PublicClientApplication at
// module load — so importing ProposalsTab from a unit test fails before a single
// assertion runs. Anything that needs to reason about status without rendering
// the app has to be able to reach it without dragging auth in behind it.
//
// ⚠️ THIS IS THE WHOLE ENUM. Leads use it too — there is no separate Lead
// vocabulary. Every value here needs a STATUS_STYLE entry: an unrecognised
// value renders STATUS_STYLE[undefined] as a blank chip AND drops the record
// out of the dashboard's status filter, which matches on exact equality, so it
// would hide the very proposals it was meant to highlight.
//
// Do NOT add "opened" or "signed" — those are derived display state and live in
// webViewBadges.js. The internal-approval values below are different: they are a
// genuine workflow state Craig filters on, not activity layered over another
// state.
//
// ADVISORY ONLY. waiting_approval / approved / changes_needed never gate
// anything — "Send to Client" is deliberately not blocked by any of them.

export const STATUSES = [
  "draft", "waiting_approval", "approved", "changes_needed",
  "sent", "won", "lost", "archived",
];

export const STATUS_STYLE = {
  draft:            { bg: "#eef2f7", fg: "#475569", label: "Draft" },
  // Amber = waiting on someone; violet = internally cleared but not yet sent;
  // red-ish = came back with changes. Deliberately distinct from "sent"/"won"
  // so a glance at the board separates internal state from client state.
  waiting_approval: { bg: "#fef3c7", fg: "#b45309", label: "Waiting approval" },
  approved:         { bg: "#ede9fe", fg: "#6d28d9", label: "Approved" },
  changes_needed:   { bg: "#ffe4e6", fg: "#be123c", label: "Changes needed" },
  sent:             { bg: "#e0f2fe", fg: "#0369a1", label: "Sent" },
  won:              { bg: "#dcfce7", fg: "#15803d", label: "Won" },
  lost:             { bg: "#fee2e2", fg: "#b91c1c", label: "Lost" },
  archived:         { bg: "#f1f5f9", fg: "#94a3b8", label: "Archived" },
};
